// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__vlc+6","navSearch":"Navbar_navSearch__ugMY9"};